/* TypeScript file generated from H1.re by genType. */
/* eslint-disable import/first */


import * as React from 'react';

// tslint:disable-next-line:no-var-requires
const H1BS = require('./H1.bs');

import {style as ReactDOMRe_style} from '../../src/shims/ReactDOMRe.shim';

// tslint:disable-next-line:interface-over-type-literal
export type Props = {
  readonly children: React.ReactNode; 
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
};

export const $$default: React.ComponentType<{
  readonly children: React.ReactNode; 
  readonly className?: string; 
  readonly style?: ReactDOMRe_style; 
  readonly testID?: string
}> = H1BS.default;

export default $$default;
